import { FormattedMessage, useIntl } from 'react-intl';
import { IconLockOutlined } from '@repo/monochrome-icons';
import cx from 'clsx';
import styles from './footer.module.css';

export function Footer() {
  const { formatMessage } = useIntl();

  return (
    <footer className={styles.footer}>
      <div
        className={cx(styles.secureCaption, 'caption', 'mb-32')}
        data-testid="sdd-payment-link-footer-secure-caption"
      >
        <IconLockOutlined aria-hidden="true" className="mr-8" height={12} width={12} />
        <FormattedMessage id="sdd-collections.payment-link-page.secure-service" />
      </div>

      <div className={styles.qontoLogo} data-testid="sdd-payment-link-footer-qonto-logo">
        <img alt="" aria-hidden="true" className="mb-16" src="/icon/qonto-logo.svg" />
      </div>

      <h4 className="title-4 mb-32" data-testid="sdd-payment-link-footer-title">
        <FormattedMessage id="sdd-collections.preview.qonto-title" />
      </h4>

      <p
        className="caption mb-32"
        dangerouslySetInnerHTML={{
          __html: formatMessage({ id: 'sdd-collections.preview.qonto-disclaimer' }, undefined, {
            ignoreTag: true,
          }),
        }}
        data-testid="sdd-payment-link-footer-disclaimer"
      />

      <p
        className="caption"
        dangerouslySetInnerHTML={{
          __html: formatMessage({ id: 'sdd-collections.preview.qonto-address' }, undefined, {
            ignoreTag: true,
          }),
        }}
        data-testid="sdd-payment-link-footer-address"
      />
    </footer>
  );
}
